<template>
	<User/>
</template>

<script>
// @ is an alias to /src
import User from '@/components/User/User.vue'

export default {
  name: 'user',
  components: {
    User
  }
}
</script>
